// Accesores típados a las globals que el template.ftl del theme login
// inyecta antes de cargar el bundle. Las dejamos NO declaradas con
// `declare global` porque otros bundles del proyecto (notablemente el
// account v3, src/widgets/IntercomLoader.tsx) ya tipan window.fdPublicConfig
// con un contrato más permisivo, y reextender con un type estricto
// rompería esa otra compilación. En su lugar exponemos getters que casten
// localmente; cualquier consumidor del login pasa por aquí.

import type { KcData } from "./kcData";
import type { FdPublicConfig } from "./fdPublicConfig";

interface LoginWindow {
  kc_data: KcData;
  fdPublicConfig: FdPublicConfig;
  fdLogin?: { runPage: (command: string) => void };
}

function loginWindow(): LoginWindow {
  return window as unknown as LoginWindow;
}

export function getKcData(): KcData {
  const w = loginWindow();
  if (!w.kc_data) {
    throw new Error(
      "window.kc_data no está poblado — ¿se está cargando el bundle fuera del theme login?",
    );
  }
  return w.kc_data;
}

export function getFdPublicConfig(): FdPublicConfig {
  const w = loginWindow();
  if (!w.fdPublicConfig) {
    throw new Error(
      "window.fdPublicConfig no está poblado — el template.ftl debe inyectarlo antes del bundle.",
    );
  }
  return w.fdPublicConfig;
}

export function exposeFdLogin(api: { runPage: (command: string) => void }) {
  loginWindow().fdLogin = api;
}
